<div class="backdrop">
  <div class="mainContainer wrapper">
    <div class="container-fluid py-5">
      <div class="row">
        <!-- Column 1: Brand & Contact -->
        <div class="col-12 col-lg-4 mb-5 mb-lg-0">
          <div class="mb-2">
            <img class="virsa_logo point"
              src="https://d3uop73ba1wtqg.cloudfront.net/uploads/WukKVLVAK6kTax6HpziPQWWZPU0av6Zo2E2U8wCs.png"
              alt="VirsaLogo" (click)="goto('/')" />
            <p class="mt-2 text-white-50 medium">Virsa The Digital Learning Private Limited</p>
          </div>

          <div class="d-flex flex-column gap-2 mb-2">
            <div class="d-flex align-items-center gap-3">
              <div class="icon-box">
                <img src="assets/images/icons/ic_phone.png" alt="Phone" class="icon-img">
              </div>
              <div>
                <p class="mb-0 text-white-50 small">Phone</p>
                <a [href]="'tel:' + contactInfo.phone" class="footer-link small">{{ contactInfo.phone }}</a>
              </div>
            </div>
            <div class="d-flex align-items-center gap-3">
              <div class="icon-box">
                <img src="https://d3uop73ba1wtqg.cloudfront.net/uploads/3T5PoJXH6rydrmlBSwZJrZHAvoFf0zOagif6bpW0.png"
                  alt="Email" class="icon-img">
              </div>
              <div>
                <p class="mb-0 text-white-50 small">Email</p>
                <a [href]="'mailto:' + contactInfo.email" class="footer-link small">{{ contactInfo.email }}</a>
              </div>
            </div>
            <div class="d-flex align-items-start gap-3">
              <div class="icon-box">
                <img src="assets/images/icons/ic_maps.png" alt="Address" class="icon-img">
              </div>
              <div>
                <p class="mb-0 text-white-50 small">Corporate Address</p>
                <p class="small">{{ contactInfo.address }}</p>
              </div>
            </div>
          </div>

          <!-- Map -->
          <div class="map-container mb-2">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.854176445389!2d77.30993297528687!3d28.574141275696586!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce442d5d2ba85%3A0x4fe73c3b81b59df5!2sMax%20Towers!5e0!3m2!1sen!2sin!4v1764224060796!5m2!1sen!2sin"
              width="100%" height="180" style="border:0; border-radius: 10px;" allowfullscreen="" loading="lazy"
              referrerpolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
          <div class="d-flex align-items-start gap-2">
            <span class="text-white-50 small">GST Number:</span>
            <span class="small">09AAICV3064A1ZH</span>
          </div>
          <div class="d-flex align-items-start gap-2 mb-2">
            <span class="text-white-50 small">CIN Number:</span>
            <span class="small">U80903DL2021PTC387250</span>
          </div>

          <div class="d-flex gap-3">
            <a *ngFor="let social of socialLinks" [href]="social.url" target="_blank" class="social-icon-link">
              <img class="logo" [src]="social.icon" [alt]="social.alt" />
            </a>
          </div>
        </div>

        <!-- Column 2: Products & Solutions -->
        <div class="col-12 col-lg-2 mb-4 mb-lg-0">
          <!-- Products Dropdown -->
          <div class="mb-4">
            <h5 class="headOver mb-3">Products</h5>
            <ul class="list-unstyled ps-2 border-start border-secondary">
              <li *ngFor="let item of products" class="mb-2">
                <a [href]="item.link" class="footer-link small">{{ item.name }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 col-lg-2 mb-4 mb-lg-0">

          <!-- Solutions Dropdown -->
          <div class="mb-4">
            <h5 class="headOver mb-3">Solutions</h5>
            <ul class="list-unstyled ps-2 border-start border-secondary">
              <li *ngFor="let item of solutions" class="mb-2">
                <a [href]="item.link" class="footer-link small">{{ item.name }}</a>
              </li>
            </ul>
          </div>


          <!-- Useful Links Dropdown -->
          <!-- <div>
            <div class="d-flex justify-content-between align-items-center cursor-pointer"
              (click)="toggleSection('usefulLinks')">
              <h5 class="headOver mb-0">Useful Links</h5>
              <span class="material-icons text-white-50 transition-transform"
                [class.rotate-180]="openSections['usefulLinks']">expand_more</span>
            </div>
            <div class="collapse-content" [class.show]="openSections['usefulLinks']">
              <ul class="list-unstyled mt-3 ps-2 border-start border-secondary">
                <li *ngFor="let link of usefulLinks" class="mb-2">
                  <a [routerLink]="[link.route]" class="footer-link small">{{ link.name }}</a>
                </li>
              </ul>
            </div>
          </div> -->
        </div>
        <div class="col-12 col-lg-2 mb-4 mb-lg-0">
          <div class="mb-4">
            <h5 class="headOver mb-3">Company</h5>
            <ul class="list-unstyled ps-2 border-start border-secondary">
              <li *ngFor="let item of company" class="mb-2">
                <a [routerLink]="[item.link]" [fragment]="item.fragment" class="footer-link small">{{ item.name }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 col-lg-2 mb-4 mb-lg-0">
          <div class="mb-4">
            <h5 class="headOver mb-3">Useful Links</h5>
            <ul class="list-unstyled ps-2 border-start border-secondary">
              <li *ngFor="let link of usefulLinks" class="mb-2">
                <a [routerLink]="[link.route]" class="footer-link small">{{ link.name }}</a>
              </li>
            </ul>
          </div>
        </div>



        <!-- Column 4: Subscribe & Downloads -->
        <!-- <div class="col-12 col-lg-4">
          <div class="mb-5">
            <h5 class="headOver mb-3">Stay Connected</h5>
            <p class="text-white-50 small mb-3">Subscribe to our newsletter for updates.</p>
            <form [formGroup]="subscriptionForm" (ngSubmit)="subscribe()">
              <div class="d-flex flex-column gap-2">
                <input type="text" formControlName="name" class="letterInput form-control" placeholder="Name" />
                <input type="email" formControlName="email" class="letterInput form-control" placeholder="Email" />
              </div>
              <div class="form-check mt-2 mb-2">
                <input class="form-check-input checkbox" type="checkbox" formControlName="myCheckbox"
                  id="subscribeCheck" />
                <label class="form-check-label text-white-50 small" for="subscribeCheck">
                  I agree to receive updates
                </label>
              </div>
              <button type="submit" class="btnGlobal--secondary w-100 py-2 small" [disabled]="subscriptionForm.invalid">
                Subscribe
              </button>
            </form>
          </div>

          <div>
            <h5 class="headOver mb-3">Download App</h5>
            <div class="d-flex gap-2 mb-4">
              <a href="https://play.google.com/store/apps/details?id=com.virsa.app" target="_blank">
                <img class="app" [src]="env + 'assets/images/android_app.png'" alt="Android App" />
              </a>
              <a href="" target="_blank">
                <img class="app" [src]="env + 'assets/images/ios_app.png'" alt="iOS App" />
              </a>
            </div>

            <div class="d-flex align-items-center gap-3">
              <a href="https://d2abnqj5vuy2s4.cloudfront.net/Iso_Registration%20Certificate.pdf" target="_blank">
                <img class="ratioApp" src="https://d3uop73ba1wtqg.cloudfront.net/images/ISO_9001-2015.png"
                  alt="ISO Certification" />
              </a>
              <a href="#" class="d-flex align-items-center gap-1 footer-link small text-decoration-none">
                <span class="material-icons small-icon">download</span>
                <span>Profile</span>
              </a>
            </div>
          </div>
        </div> -->
      </div>

      <!-- Footer Bottom -->
      <div class="row pt-4 mt-4 border-top border-secondary">
        <div class="col-12 text-center">
          <p class="mb-1 text-white-50 small">Made with love in India for the world</p>
          <span class="vtext text-white small">2026 © Virsa. All Rights Reserved.</span>
        </div>
      </div>
    </div>
  </div>
</div>
